import {
  Pill,
  Syringe,
  Droplets,
  Wind,
  Sparkles,
  FlaskConical,
  Pipette,
  Eye,
  Ear,
  Package,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

const DOSAGE_FORM_ICONS: Record<string, LucideIcon> = {
  tablet: Pill,
  tablets: Pill,
  pill: Pill,
  capsule: Pill,
  capsules: Pill,
  caplet: Pill,
  injection: Syringe,
  injectable: Syringe,
  "pre-filled syringe": Syringe,
  "pre-filled pen": Syringe,
  pen: Syringe,
  vial: FlaskConical,
  solution: Droplets,
  liquid: Droplets,
  oral: Droplets,
  suspension: Droplets,
  syrup: Droplets,
  drops: Pipette,
  "eye drops": Eye,
  ophthalmic: Eye,
  "ear drops": Ear,
  otic: Ear,
  cream: Sparkles,
  ointment: Sparkles,
  gel: Sparkles,
  topical: Sparkles,
  patch: Sparkles,
  inhaler: Wind,
  nasal: Wind,
  spray: Wind,
  aerosol: Wind,
  powder: FlaskConical,
};

export function getDosageIcon(form?: string | null): LucideIcon {
  if (!form) return Package;
  const key = form.toLowerCase().trim();
  if (DOSAGE_FORM_ICONS[key]) return DOSAGE_FORM_ICONS[key];
  for (const [k, icon] of Object.entries(DOSAGE_FORM_ICONS)) {
    if (key.includes(k)) return icon;
  }
  return Package;
}

export function isPlaceholderImage(src: string): boolean {
  return !src || src === "/images/medication-placeholder.svg" || src.includes("medication-placeholder");
}
